<template>
  <layout-main-inner title="非唯一码">
    <layout-card-wrap>
      <el-form
        label-width="85px"
        @submit.native.prevent>
        <el-row
          :gutter="8"
          type="flex">
          <el-col :span="6">
            <el-form-item label="非唯一码：">
              <el-input
                v-model="config.uniqueProductCode"
                clearable=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width="0">
              <el-button
                type="primary"
                @click="handleCurrentChange(1)">查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        border
        :data="list">
        <el-table-column
          label="非唯一码"
          fixed="left"
          min-width="160"
          prop="uniqueProductCode"></el-table-column>
        <el-table-column
          label="委托单数量"
          width="100"
          prop="recognitionCnt"></el-table-column>
        <el-table-column
          label="操作"
          width="70">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="deleteRow(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"></el-pagination>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import Ai from '@/service//ai.js'
export default {
  name: 'NotUpcsPage',
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      config: { pageNum: 1, pageSize: 10, uniqueProductCode: '' }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    deleteRow(row) {
      this.$confirm('此操作将永久删除该非唯一码, 是否继续?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          Ai.removefromuniqueproductcodeblacklistbyid({ id: row.id })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if (result === 0) {
                this.$message.success('删除成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      Ai.getuniqueproductcodeblacklist({ ...this.config })
        .then(res => {
          this.loading = false
          const { result, message, records, total } = res.data
          if (result === 0) {
            this.list = records
            this.total = total
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
